/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */

/**
 * Why a patient has nothing to resend. String-serialized on the wire.
 */
export type NothingToResendReason =
  (typeof NothingToResendReason)[keyof typeof NothingToResendReason];

export const NothingToResendReason = {
  NoStatement: "NoStatement",
  NothingSent: "NothingSent",
  PaidWithoutReceipt: "PaidWithoutReceipt",
} as const;
